(function () {

    "use strict";

    function bodyEditController( ) {

    }

    bodyEditController.$inject = [];

    angular.module("sphforms.main")
        .component("sphformsBodyEdit", {
            controller: bodyEditController,
            bindings: {
                idEntity: "<"
            },
            transclude: true,
            require: {
                basicFormCtrl: '^sphformsBasicForm'
            },
            templateUrl: "modules/main/components/ui/basicEdit/bodyEdit/bodyEdit.template.html"
        });

}());